<template>
    <div id="app">
        <navTag></navTag>
        <router-view/>
        <footerCom></footerCom>
        <!--右侧-->
        <!-- <div class="rightLxBox" @mouseenter="hoverBoxFlag=true" @mouseleave="hoverBoxFlag=false">
            <img src="./assets/联系我们@2x.png" height="28" width="32"/>
            <span class="lx">联系我们</span>
            <div class="hoverBox" v-show="hoverBoxFlag">
                <div class="hoverBoxTitle">服务咨询</div>
                <p>电话：<span>0755-86969845</span></p>
                <p>(工作日 9:30-18:30)</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div> -->
    </div>
</template>

<script>
    import navTag from "@/components/nav"
    import footerCom from "@/components/footer"

    export default {
        components: {
            navTag,
            footerCom
        },
        data() {
            return {
                hoverBoxFlag: false
            }
        }
    }
</script>

<style lang="scss">
    #app {
        color: #2c3e50;
    }

    /*阿里普惠字体*/
    @font-face {
        font-family: 'webfont';
        font-display: swap;
        src: url('//at.alicdn.com/t/webfont_nfst9huy6yr.eot'); /* IE9*/
        src: url('//at.alicdn.com/t/webfont_nfst9huy6yr.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('//at.alicdn.com/t/webfont_nfst9huy6yr.woff2') format('woff2'),
        url('//at.alicdn.com/t/webfont_nfst9huy6yr.woff') format('woff'), /* chrome、firefox */
        url('//at.alicdn.com/t/webfont_nfst9huy6yr.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
        url('//at.alicdn.com/t/webfont_nfst9huy6yr.svg#Alibaba-PuHuiTi-Regular') format('svg'); /* iOS 4.1- */
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        list-style: none;
        font-family: "PingFangSC-Regular", "webfont", "Helvetica Neue", Helvetica, "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    }

    a {
        text-decoration: none;
    }

    button {
        border: none;
        outline: none;
    }

    /*swiper 匀速位移*/
    .swiper-container .swiper-wrapper {
        -webkit-transition-timing-function: linear !important; /*之前是ease-out*/
        -moz-transition-timing-function: linear;
        -o-transition-timing-function: linear;
        transition-timing-function: linear;
    }

    #yxCenter {
        .swiper-container {
            height: 490px;
        }
    }


    .swiper-pagination {
        bottom: 0px !important;

        span {
            width: 12px;
            height: 12px;
            opacity: 0.6;
            background: transparent;
            border: 1px solid #92939E;
        }

        .swiper-pagination-bullet-active {
            background: #92939E;
        }
    }

    /*首页标题*/
    .headline {
        margin-bottom: 50px;
        font-size: 60px;
        line-height: 84px;
        color: #152346;
        text-align: center;
    }

    // 弹框
    .alertBox {
        position: fixed;
        width: 500px;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 2000;
        background: #fff;
        box-shadow: 0 0 30px -25px black;

        .alertBoxHeader {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            height: 56px;
            padding: 0 30px;
            background-image: linear-gradient(-45deg, #1C39DC 0%, #4161FF 100%);

            span {
                font-size: 16px;
                color: #FFFFFF;
                text-align: justify;
                line-height: 24px;
            }

            img {
                cursor: pointer;
            }
        }

        .alertBoxVal {
            padding: 34px 30px 66px;
            background: url("./assets/alertBg.png") no-repeat center;

            div {
                margin-bottom: 16px;
                opacity: 0.8;
                font-size: 16px;
                color: #444F6B;
                text-align: justify;
                line-height: 24px;
            }

            p {
                margin-bottom: 6px;
                font-size: 16px;
                color: #697289;
                text-align: justify;
                line-height: 24px;

                &:last-child {
                    margin-bottom: 0;
                }

                span {
                    color: #4161FF;
                }
            }
        }
    }

    .rightLxBox {
        position: fixed;
        right: 20px;
        bottom: 200px;
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 80px;
        height: 100px;
        cursor: pointer;
        background-image: linear-gradient(270deg, #1C39DC 0%, #4161FF 100%);

        &:after {
            position: absolute;
            left: -20px;
            top: 0;
            content: "";
            width: 20px;
            height: 100%;
        }

        .lx {
            margin-top: 10px;
            font-size: 14px;
            color: #FFFFFF;
            text-align: justify;
        }

        .hoverBox {
            position: absolute;
            margin-right: 20px;
            left: -200px;
            bottom: 0;
            padding: 26px 28px 30px;
            background: #fff;
            box-shadow: 0 0 30px -25px black;

            .hoverBoxTitle {
                margin-bottom: 4px;
                font-size: 16px;
                color: #444F6B;
                text-align: justify;
                line-height: 24px;
            }

            p {
                opacity: 0.8;
                font-size: 12px;
                color: #444F6B;
                text-align: justify;
                line-height: 24px;

                span {
                    color: #4161FF;
                }
            }
        }
    }

</style>
